// FormFrame/fields/testFormSpec.tsx
import * as React from "react"
import type { FormSpec } from "../formSpec"

export const testFormSpec: FormSpec = {
    form: {
        mode: "all",
        reValidateMode: "onChange",
        autoComplete: "off",
        emptyOnMount: true,
        validateOnMount: false,
    } as any,

    defaults: {
        hiddenToken: "abc123",
        a_text: "",
        b_email: "",
        c_password: "",
        d_number: "",
        e_date: "",
        f_textarea: "",
        g_select: "",
        h_multiselect: [],
        i_radio: "",
        j_checkboxA: false,
        k_checkboxB: false,
    },

    submit: {
        action: "/api/form/test",
        method: "POST",
        label: "Absenden",
        loadingLabel: "Lädt…",
        errorText: "Fehler",
    } as any,

    ui: {
        frame: true,
        showDividerBeforeSubmit: true,
        header: {
            align: "left",
            title: "Testformular (alle Feldtypen)",
            subtitle: "Alle Feldtypen, bewusst durcheinander in gemischten Zeilen.",
        },
    } as any,

    fields: {
        hiddenToken: { type: "hidden", name: "hiddenToken", label: "Token" } as any,

        a_text: {
            type: "text",
            name: "a_text",
            label: "Text",
            placeholder: "Irgendwas…",
            required: true,
            rules: [{ type: "required", message: "Text fehlt" }],
        } as any,

        b_email: {
            type: "email",
            name: "b_email",
            label: "E-Mail",
            placeholder: "a@b.de",
            required: true,
            rules: [{ type: "required", message: "E-Mail fehlt" }],
        } as any,

        c_password: {
            type: "password",
            name: "c_password",
            label: "Passwort",
            placeholder: "••••••••",
            required: true,
            rules: [{ type: "required", message: "Passwort fehlt" }],
        } as any,

        d_number: {
            type: "number",
            name: "d_number",
            label: "Number",
            placeholder: "7",
            min: 0,
            max: 999,
            step: 1,
            required: true,
            rules: [{ type: "required", message: "Number fehlt" }],
        } as any,

        e_date: {
            type: "date",
            name: "e_date",
            label: "Datum",
            placeholder: "TT.MM.JJJJ",
            required: true,
            rules: [{ type: "required", message: "Datum fehlt" }],
        } as any,

        f_textarea: {
            type: "textarea",
            name: "f_textarea",
            label: "Textarea",
            placeholder: "Mehrzeilig…",
            rows: 8,
            required: true,
            description: "Bitte möglichst genau beschreiben", // ← DAS ist der Subtext
            rules: [{ type: "required", message: "Textarea fehlt" }],
            fill: 220
        } as any,

        g_select: {
            type: "select",
            name: "g_select",
            label: "Select",
            placeholder: "Bitte wählen",
            required: true,
            rules: [{ type: "required", message: "Select fehlt" }],
            options: [
                { value: "one", label: "One" },
                { value: "two", label: "Two" },
                { value: "three", label: "Three" },
            ],
        } as any,

        h_multiselect: {
            type: "multiselect",
            name: "h_multiselect",
            label: "Multiselect",
            placeholder: "Auswählen",
            maxItems: 3,
            searchable: true,
            required: true,
            rules: [{ type: "required", message: "Mind. 1 Item wählen" }],
            options: [
                { value: "a", label: "A" },
                { value: "b", label: "B" },
                { value: "c", label: "C" },
                { value: "d", label: "D" },
            ],
        } as any,

        i_radio: {
            type: "radio",
            name: "i_radio",
            label: "Radio",
            layout: "row",
            wrap: false,
            required: true,
            rules: [{ type: "required", message: "Radio fehlt" }],
            options: [
                { value: "r1", label: "R1" },
                { value: "r2", label: "R2" },
                { value: "r3", label: "R3" },
            ],
        } as any,

        j_checkboxA: {
            type: "checkbox",
            name: "j_checkboxA",
            label: "Checkbox A",
            inlineLabel: "Ich stimme A zu",
            required: true,
            rules: [{ type: "required", message: "Checkbox A fehlt" }],
        } as any,

        k_checkboxB: {
            type: "checkbox",
            name: "k_checkboxB",
            label: "Checkbox B",
            inlineLabel: "Ich stimme B zu",
            required: true,
            rules: [{ type: "required", message: "Checkbox B fehlt" }],
        } as any,

        div1: { type: "divider", name: "div1", margin: "md" } as any,
    } as any,

    rowHeightPx: 120,

    rows: [
        { columns: [{ field: "g_select", width: 4 }, { field: "j_checkboxA", width: 8 }] },
        { columns: [{ field: "c_password", width: 4 }, { field: "e_date", width: 4 }, { field: "i_radio", width: 4, wrap: true }] },
        { columns: [{ field: "h_multiselect", width: 7 }, { field: "b_email", width: 5 }] },

        {
            columns: [
                { field: "f_textarea", width: 6 },
                {

                    width: 6,
                    stack: {
                        columns: [
                            { field: "d_number", width: 12 },
                            { field: "a_text", width: 12 },
                            { field: "k_checkboxB", width: 12 },
                        ],
                    }
                },
            ],
        },

        { columns: [{ field: "div1", width: 12 }] },
    ] as any,
}
